/* Shopify predictive search inside the existing approved dialog. GET requests only. */
(() => {
  'use strict';
  const dialog = document.querySelector('#site-search');
  if (!dialog || dialog.dataset.liveSearch) return;
  dialog.dataset.liveSearch = 'true';
  const query = dialog.querySelector('#site-query');
  const form = dialog.querySelector('.site-search-form');
  const results = dialog.querySelector('.site-search-results');
  const status = dialog.querySelector('.site-result-count');
  const clear = dialog.querySelector('.site-clear');
  const root = window.Shopify?.routes?.root || '/';
  const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
  const normalize = value => String(value).normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  const quiet = () => new URLSearchParams(location.search).get('quiet') === '1' || document.body.dataset.quiet === 'true';
  const node = (tag, text, className) => {
    const el = document.createElement(tag); if (text !== undefined) el.textContent = text;
    if (className) el.className = className; return el;
  };
  let timer, controller, sequence = 0;
  function safeLink(value, gentle = false) {
    try {
      const url = new URL(value, location.origin);
      if (!/^https?:$/.test(url.protocol) || url.origin !== location.origin) return null;
      if (quiet() || gentle) url.searchParams.set('quiet', '1');
      if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
      return url;
    } catch { return null; }
  }
  function link(text, value, className, gentle = false) {
    const url = safeLink(value, gentle); if (!url) return null;
    const a = node('a', text, className); a.href = url.href; return a;
  }
  function allResults(value) {
    const url = new URL(root + 'search', location.origin);
    url.searchParams.set('q', value);
    url.searchParams.set('type', 'product,page,article');
    url.searchParams.set('options[prefix]', 'last');
    return link('See all results →', url, 'site-text-button');
  }
  function help() { return link('Ask us a question', root + 'pages/contact', 'site-help-link'); }
  function suggestions() {
    const group = node('div', undefined, 'site-suggestions');
    [['Photos', 'photos'], ['Shipping', 'shipping'], ['The making', 'making']].forEach(([label, term]) => {
      const button = node('button', label); button.type = 'button'; button.dataset.liveQuery = term; group.append(button);
    });
    return group;
  }
  function cancel() { clearTimeout(timer); controller?.abort(); controller = null; sequence++; }
  function reset() {
    results.replaceChildren(); status.textContent = ''; results.removeAttribute('aria-busy');
    clear.hidden = !query.value;
    if (history.state?.pawSiteSearch) history.replaceState({...history.state, pawSiteQuery: query.value}, '', location.href);
  }
  function initial() { reset(); status.textContent = 'A few places to start'; results.append(suggestions(), help()); }
  function showError(term) {
    reset(); status.textContent = 'Search suggestions are unavailable.';
    const box = node('div', undefined, 'site-empty');
    box.append(node('h3', 'We couldn’t load the results.'), node('p', 'Try again, or open the full search page.'));
    const retry = node('button', 'Try again', 'site-action'); retry.type = 'button'; retry.dataset.liveRetry = '';
    box.append(retry, allResults(term), help()); results.append(box);
  }
  function collect(data, term) {
    if (!data?.resources?.results || typeof data.resources.results !== 'object') throw new Error('Invalid search response');
    const raw = data.resources.results, rows = [], seen = new Set();
    const localIndex = Array.isArray(window.PAW_SITE_SEARCH) ? window.PAW_SITE_SEARCH : [];
    const approved = new Map(localIndex.map(item => [new URL(item.href, location.origin).pathname, item]));
    const add = (item, group) => {
      if (!item || typeof item.title !== 'string' || typeof item.url !== 'string') return;
      const url = safeLink(item.url); if (!url) return;
      const tags = Array.isArray(item.tags) ? item.tags : typeof item.tags === 'string' ? item.tags.split(',').map(t => t.trim()) : [];
      if (tags.includes('pc-unlisted') || /\/christmas-gift-for-someone-who-lost-a-pet\/?$/.test(url.pathname) || /\/products\/rush-creation-1-week\/?$/.test(url.pathname)) return;
      if (seen.has(url.pathname)) return; seen.add(url.pathname);
      const previous = approved.get(url.pathname);
      rows.push({title: group === 'Stories' && previous && !tags.includes('pc-live-content') ? previous.title : item.title,
        href: url, group, quiet: previous?.quiet || tags.includes('pc-quiet') || tags.includes('Remembering a pet')});
    };
    [['products', 'Products'], ['pages', 'Help & guides'], ['articles', 'Stories']].forEach(([key, group]) => {
      if (raw[key] !== undefined && !Array.isArray(raw[key])) throw new Error('Invalid search group');
      (raw[key] || []).forEach(item => add(item, group));
    });
    // Retain the approved help synonyms and deep links; products/new content come
    // from Shopify. This is useful for phrases absent from legacy page bodies.
    const words = normalize(term).split(' ').filter(Boolean).map(w => w.length > 4 && w.endsWith('s') ? w.slice(0, -1) : w);
    localIndex.filter(item => item.group === 'Help & guides' && words.every(w => normalize(item.title + ' ' + item.terms).includes(w)))
      .forEach(item => add({title: item.title, url: item.href}, item.group));
    return rows;
  }
  function showRows(rows, term) {
    reset(); status.textContent = rows.length ? `${rows.length} suggested ${rows.length === 1 ? 'result' : 'results'}` : 'No suggestions found';
    if (!rows.length) {
      const box = node('div', undefined, 'site-empty');
      box.append(node('h3', `No matches for “${term}”.`), node('p', 'Try a different word, or open the full search page.'), suggestions(), help());
      results.append(box);
    } else {
      ['Products', 'Help & guides', 'Stories'].forEach(group => {
        const matches = rows.filter(item => item.group === group); if (!matches.length) return;
        const section = node('section', undefined, 'site-result-group'); section.append(node('h3', group));
        matches.forEach(item => {
          const a = link('', item.href, 'site-result-link', item.quiet); if (!a) return;
          const arrow = node('span', '→'); arrow.setAttribute('aria-hidden', 'true'); a.append(node('span', item.title), arrow); section.append(a);
        }); results.append(section);
      });
    }
    results.append(allResults(term));
  }
  function search(immediate = false) {
    cancel(); const current = sequence; const term = query.value.trim().slice(0, 160);
    if (!term) { initial(); return; }
    reset(); status.textContent = 'Searching'; results.setAttribute('aria-busy', 'true');
    const loading = node('div', undefined, 'site-loading'); const spinner = node('span', undefined, 'site-spinner'); spinner.setAttribute('aria-hidden', 'true');
    loading.append(spinner, node('p', 'Searching…')); results.append(loading);
    timer = setTimeout(async () => {
      controller = new AbortController(); const requestController = controller; const timeout = setTimeout(() => requestController.abort(), 8000);
      try {
        const url = new URL(root + 'search/suggest.json', location.origin);
        url.searchParams.set('q', term); url.searchParams.set('resources[type]', 'product,page,article');
        url.searchParams.set('resources[limit]', '4'); url.searchParams.set('resources[limit_scope]', 'each');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,body,tag');
        const response = await fetch(url, {signal: requestController.signal, credentials: 'same-origin', headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json(); if (current !== sequence || !dialog.open) return;
        showRows(collect(data, term), term);
      } catch {
        if (current === sequence && dialog.open) showError(term);
      } finally { clearTimeout(timeout); }
    }, immediate ? 0 : 240);
  }
  // Capture only search-specific events before the original static search's
  // listeners. Its open/close/focus/history/menu/newsletter behavior stays intact.
  dialog.addEventListener('input', event => { if (event.target !== query) return; event.stopImmediatePropagation(); search(); }, true);
  dialog.addEventListener('submit', event => { if (event.target !== form) return; event.preventDefault(); event.stopImmediatePropagation(); search(true); }, true);
  dialog.addEventListener('click', event => {
    const button = event.target.closest('button'); if (!button) return;
    if (button === clear) { event.preventDefault(); event.stopImmediatePropagation(); query.value = ''; search(); query.focus(); }
    else if (button.hasAttribute('data-live-retry')) { event.preventDefault(); event.stopImmediatePropagation(); search(true); }
    else if (button.dataset.liveQuery || button.closest('.site-suggestions')) {
      event.preventDefault(); event.stopImmediatePropagation();
      query.value = button.dataset.liveQuery || ({Photos: 'photos', Shipping: 'shipping', 'The making': 'making'}[button.textContent] || button.textContent);
      search(true); query.focus();
    }
  }, true);
  new MutationObserver(() => { if (dialog.open) search(true); else cancel(); }).observe(dialog, {attributes: true, attributeFilter: ['open']});
  addEventListener('popstate', () => { if (dialog.open) search(true); else cancel(); });
  if (dialog.open) search(true);
})();
